<span *ngIf="keyInflection" triggers="mouseenter:mouseleave" placement="right"
      [ngbPopover]="keyInflection ? 'Key Inflection' : !keyInflection ? '' : keyInflection ? 'Key Inflection' : null">
  <span [ngClass]="keyInflection ? 'key-inflection' : 'empty'">KI</span>
</span>
